import { render } from "./SelectFake.vue?vue&type=template&id=344e309f&scoped=true"
import script from "./SelectFake.vue?vue&type=script&lang=js"
export * from "./SelectFake.vue?vue&type=script&lang=js"

import "./SelectFake.vue?vue&type=style&index=0&id=344e309f&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344e309f"]])

export default __exports__